import { EditProfileForm } from '../components/EditProfileForm/EditProfileForm';

export const EditProfileScreen = () => {
  return (
    <div>
      Editar Perfil
      <EditProfileForm />
    </div>
  );
};
